import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ user, permission, children }) => {
    // console.log(user)
    if (!user?.permissions?.includes(permission)) {
        return null; // redirect if no permission
    }
    return children;
};

export default ProtectedRoute;